import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: 'app-wizardlayoutnew',
  templateUrl: './wizardlayoutnew.component.html',
  styleUrls: ['./wizardlayoutnew.component.scss']
})
export class WizardlayoutnewComponent implements OnInit {
  mainFormGroup: FormGroup;
  currentStep = 0;

  constructor(private formBuilder: FormBuilder) { }


  ngOnInit() {
    this.mainFormGroup = this.formBuilder.group({
      formCount: 1,
      stepData: this.formBuilder.array([
        this.formBuilder.group({
          name: ["", Validators.required]
        })
      ])
    });
    // this.firstFormGroup = this.formBuilder.group({
    //   firstCtrl: ["", Validators.required]
    // });
    // this.secondFormGroup = this.formBuilder.group({
    //   secondCtrl: ["", Validators.required]
    // });
  }

  addInput(currentIndex:any): void {
    const arrayControl = <FormArray>this.mainFormGroup.controls["stepData"];
    let newGroup = this.formBuilder.group({
      name: ["", Validators.required]
    });
    arrayControl.push(newGroup);
    const content = this;
    setTimeout(element => {
      content.currentStep = currentIndex + 1;
    });
  }
  delInput(index: number): void {
    const arrayControl = <FormArray>this.mainFormGroup.controls["stepData"];
    arrayControl.removeAt(index);
  }

}
